export default __webpack_public_path__ + "static/media/fapeal.3a3e7433.svg";